__turbopack_context__.v({
  "checkMark": "KvyP3W_checkMark",
  "checkmark": "KvyP3W_checkmark",
  "chevronButton": "KvyP3W_chevronButton",
  "cnoComparison": "KvyP3W_cnoComparison",
  "cross": "KvyP3W_cross",
  "dropdownArrow": "KvyP3W_dropdownArrow",
  "dropdownHeader": "KvyP3W_dropdownHeader",
  "dropdownText": "KvyP3W_dropdownText",
  "featureCol": "KvyP3W_featureCol",
  "featureHeader": "KvyP3W_featureHeader",
  "featureRow": "KvyP3W_featureRow",
  "featureValue": "KvyP3W_featureValue",
  "headSection": "KvyP3W_headSection",
  "headerCell": "KvyP3W_headerCell",
  "mobileContainer": "KvyP3W_mobileContainer",
  "mobileStickyHeader": "KvyP3W_mobileStickyHeader",
  "mobileTable": "KvyP3W_mobileTable",
  "pro": "KvyP3W_pro",
  "stickyTableHeader": "KvyP3W_stickyTableHeader",
  "table": "KvyP3W_table",
  "tableContainer": "KvyP3W_tableContainer",
  "ultrahumanCol": "KvyP3W_ultrahumanCol",
  "ultrahumanHeader": "KvyP3W_ultrahumanHeader",
});
